import { type ServiceType } from '../types/ServiceType';

export const OrderDeliveryServices: { [K in ServiceType]: K } = {
    YANDEX_DELIVERY: 'YANDEX_DELIVERY',
    CDEK: 'CDEK',
    META_SHIP_RUSSIAN_POST: 'META_SHIP_RUSSIAN_POST',
    META_SHIP_PECOM: 'META_SHIP_PECOM',
    META_SHIP_DALLI: 'META_SHIP_DALLI',
    SELF: 'SELF',
    MERCHANT_SHIP: 'MERCHANT_SHIP',
    YANDEX_MARKET_FBO: 'YANDEX_MARKET_FBO',
    OZON: 'OZON',
    HOLODILNIK: 'HOLODILNIK',
};
